// eslint-disable-next-line import/no-anonymous-default-export
export default {
  home: {
    name: "首页",
    welcome: "欢迎使用云扩RPA管理后台!",
  },
};
